module.exports = __webpack_public_path__ + "media/flags/es-ct-45d2d25e.svg";